module.exports = __webpack_public_path__ + "img/VetsGo-Login-01.698d873d.svg";